import changeViewportScale from './changeViewportScale.js';
import correctShift from './correctShift.js';

// Named
export { changeViewportScale, correctShift };

// Default
export default {
  changeViewportScale,
  correctShift,
};
